// extracted by mini-css-extract-plugin
export default {"proofBar":"ProofBar_proofBar__AywBh","proofItem":"ProofBar_proofItem__t3zlH","value":"ProofBar_value__OcThl","label":"ProofBar_label__3Mutz"};